import React from 'react';
import './src/index.css';
import './src/i18n';
import I18nextProvider from './src/i18n/I18nextProvider';
import { GatsbyBrowser } from 'gatsby';
import { detectUserLanguage, redirectToLanguage, defaultLanguage } from './src/utils/languageDetection';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return <I18nextProvider>{element}</I18nextProvider>;
};

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  console.log('Gatsby client entry, current path:', window.location.pathname);
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo(0, 0);
  }
};

// Make i18n available globally for debugging (only in development)
export const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
  if (process.env.NODE_ENV === 'development') {
    import('./src/i18n').then((i18nModule) => {
      (window as any).i18n = i18nModule.default;
    });
  }
};
